{"id":"ProductDetail.Info.Description","prefabs":{"default":{"children":[{"component":"ProductDetail.Info.Description","options":"options:*"}]}}}